const registry = [];

export function registerRenderer(detector, Component) {
  registry.push({ detector, Component });
}

export function getRenderer(content) {
  for (const entry of registry) {
    const match = entry.detector(content);
    if (match) return { Component: entry.Component, match };
  }
  return null;
}
